import { LeadTaskModel } from '@/typings/models/LeadTask';
import { Button } from 'antd';
import { CheckOutlined, CloseOutlined } from '@ant-design/icons';
import * as React from 'react';
import { useState } from 'react';
import { useIntl } from 'umi';
import { partialEditLeadTaskRequest } from '@/services/api/leadTask';
import { hasPermissionToEditTask } from '@/utils/task';
import styles from './index.less';
import classNames from 'classnames';

type IDoTaskProps = {
  task: LeadTaskModel;
  updateRequest: () => void;
  size?: number;
  className?: string;
  onClick?: (task: LeadTaskModel) => void;
}

const DoTask: React.FC<IDoTaskProps> = ({ task, className, updateRequest, onClick, size = 24 }: IDoTaskProps) => {
  const intl = useIntl();
  const [loading, setLoading] = useState(false);

  const handleClick = (e: React.MouseEvent) => {
    e.stopPropagation();

    if (!hasPermissionToEditTask(task)) return;
    if (task.retired_at) return;

    setLoading(true);
    // PATCH only the flag — a full PUT would clobber description with the
    // truncated description_summary that list payloads carry.
    partialEditLeadTaskRequest({
      params: {
        taskId: task.id,
      },
      data: {
        is_completed: !task.is_completed,
      },
    }).then(() => {
      setLoading(false);
      updateRequest();
      onClick?.(task);
    }).catch(() => {
      setLoading(false);
    });
  };

  const Icon = task.retired_at ? CloseOutlined : CheckOutlined;
  const inferredClassName = !task.is_completed && !task.retired_at ? styles.doTaskIconHidden : null;

  return task.can_edit ? (
    <Button
      loading={loading}
      icon={<Icon className={inferredClassName} />}
      onClick={handleClick}
      style={{
        '--task-checkbox-size': `${size || 24}px`,
      }}
      role={'task-checkbox'}
      aria-checked={Boolean(task.is_completed)}
      aria-label={intl.formatMessage({ id: 'pages.tasks.markDone', defaultMessage: 'Mark as done' })}
      color={'primary'}
      className={classNames(styles.doTaskButton, className)}
      disabled={task.retired_at}
      variant={'outlined'}
      size={'small'}
    />
  ) : null;
};

export default DoTask;
